const fileManagement = {
  bindings: {
    packages: '<',
    allDescriptors: '<',
    fleetList: '<',
  },
  templateUrl: '/modules/packageManagement/file-management/file-management.html',
  controller: 'fileManagementController',
};

angular
  .module('package-management.module')
  .component('fileManagement', fileManagement)
  .config(function($stateProvider) {
    $stateProvider.state('files.filemanagement', {
      url: '/file-management',
      views: {
        'management@files': 'fileManagement',
      },
      resolve: {
        packages: PackageService => PackageService.getAllPackages(),
        allDescriptors: PackageService => PackageService.getAllDescriptors()
      },
    });
  });
